<template>
  <div class="tab-pane fade show active" role="tabpanel">
    <InvoiceManagementComponent
      :companies="companies"
      :isAdmin="isAdmin"
      :pendingInvoiceItems="[]"
      :defaultInvoiceNumber="''"
      :pendingPayoutByCompanyId="{}"
      initialTab="invoice-history"
    />
  </div>
</template>

<script setup lang="ts">
import InvoiceManagementComponent from "@/dashboard/invoice_management/InvoiceManagementComponent.vue";
import type { Company } from "@/types";

defineProps<{
  companies: Company[];
  isAdmin: boolean;
}>();
</script>
